export enum DetailSidebarType {
  HrisEmployee = "hris-employee",
  HrisEmployeeEvent = "hris-employee-event",
  HrisIntegration = "hris-integration",
  HrisLocation = "hris-location",
  HrisRole = "hris-role",
  HrisSync = "hris-sync",
  OrgSftpIntegration = "org-sftp-integration",
  HrisCsvUpload = "hris-csv-upload",
  RemoteHrisSftpCsv = "remote-hris-sftp-csv",
  User = "user",
  Location = "location",
  TraineeLibraryItem = "trainee-library-item",
  NewStoreOpeningsList = "new-store-openings-list",
  GuestFeedbackIntegration = "guest-feedback-integration",
  GuestFeedbackSync = "guest-feedback-sync",
  GuestFeedbackCsvUpload = "guest-feedback-csv-upload",
}

export const DetailSidebarTypeToTitle: Record<DetailSidebarType, string> = {
  [DetailSidebarType.HrisEmployee]: "HRIS Employee",
  [DetailSidebarType.HrisEmployeeEvent]: "HRIS Employee Snapshot",
  [DetailSidebarType.HrisIntegration]: "HRIS Integration",
  [DetailSidebarType.HrisLocation]: "HRIS Location",
  [DetailSidebarType.HrisRole]: "HRIS Role",
  [DetailSidebarType.HrisSync]: "HRIS Sync",
  [DetailSidebarType.OrgSftpIntegration]: "SFTP Integration",
  [DetailSidebarType.HrisCsvUpload]: "CSV Sync",
  [DetailSidebarType.RemoteHrisSftpCsv]: "Remote CSV File",
  [DetailSidebarType.User]: "User",
  [DetailSidebarType.Location]: "Location",
  [DetailSidebarType.TraineeLibraryItem]: "Library Item",
  [DetailSidebarType.NewStoreOpeningsList]: "New store openings",
  [DetailSidebarType.GuestFeedbackIntegration]: "Guest Feedback Integration",
  [DetailSidebarType.GuestFeedbackSync]: "Integration Sync",
  [DetailSidebarType.GuestFeedbackCsvUpload]: "CSV Upload",
};
